import React, { FC } from 'react'
import Dots from '../Dots/Dots';

interface HeadingProps {
    title?: string,
    subTitle?: React.ReactNode,
    text?: string,
    className?: string,
    dotsPosition?: 'afterSubtitle' | 'afterText'
}

const Heading: FC<HeadingProps> = ({ title, subTitle, text, className, dotsPosition = 'afterText' }) => {
    return (
        <div className={`flex justify-center items-center relative px-4 md:px-0 ${className}`}>
            <div className='flex flex-col justify-center items-center gap-2 md:gap-3'>
                <div className='text-yellow text-center text-base md:text-lg 3xl:text-2xl tracking-widest uppercase font-google-sans-semibold'>{title}</div>
                <div data-aos="fade-up" data-subtitle className="font-google-sans-medium  text-2xl sm:text-3xl md:text-4xl 3xl:text-6xl text-center whitespace-pre-line">
                    {subTitle}
                </div>
                {dotsPosition === 'afterSubtitle' && (
                    <Dots width='w-5 md:w-7' height='h-5 md:h-7' className='my-2 md:my-3' />
                )}
                {text && <div className='text-center opacity-[70%]  text-sm sm:text-base md:text-lg xl:text-xl 2xl:text-2xl 3xl:text-3xl px-4 sm:px-16 md:px-24 lg:px-36 xl:px-0 xl:max-w-4xl 2xl:max-w-5xl 3xl:max-w-6xl 2xl:mx-auto whitespace-pre-line'>{text}</div>}
                {dotsPosition === 'afterText' && (
                    <Dots width='w-5 md:w-7' height='h-5 md:h-7' className='my-2 md:my-3' />
                )}
            </div>
        </div>
    )
}

export default Heading
